import { Chips } from '@cian/ui-kit';
import { useState, useCallback, useEffect } from 'react';
import { useSelector } from 'react-redux';

import { useContentItems, useContentTabLink } from './hooks';
import { trackClickRating } from './tracking';
import { ContentRating } from '../../components/ContentRating';
import { ContentTabsLayout } from '../../components/ContentTabsLayout';
import { CONTENT_RATING_URL } from '../../constants/links';
import { selectBlogs, selectAdvices, selectCompany, selectQuestions, selectTrackingProducts } from '../../slices';

export enum EInfoTabs {
  Blogs = 'blogs',
  Advices = 'advices',
  Questions = 'questions',
}

export const ContentTabsContainer = () => {
  const [activeTab, setActiveTab] = useState<string>(EInfoTabs.Blogs);
  const blogs = useSelector(selectBlogs);
  const advices = useSelector(selectAdvices);
  const questions = useSelector(selectQuestions);
  const company = useSelector(selectCompany);
  const products = useSelector(selectTrackingProducts);

  const items = useContentItems(activeTab);
  const tabLink = useContentTabLink(activeTab);

  const handleClickRating = useCallback(() => {
    trackClickRating(products);
  }, [products]);

  const handleTabChange = useCallback((value: string[]) => {
    if (value[0]) {
      setActiveTab(value[0]);
    }
  }, []);

  useEffect(() => {
    if (blogs.totalCount) {
      setActiveTab(EInfoTabs.Blogs);

      return;
    }

    if (advices.totalCount) {
      setActiveTab(EInfoTabs.Advices);

      return;
    }

    if (questions.totalCount) {
      setActiveTab(EInfoTabs.Questions);

      return;
    }
  }, [advices.totalCount, blogs.totalCount, questions.totalCount]);

  if (!blogs.totalCount && !advices.totalCount && !questions.totalCount) {
    return null;
  }

  return (
    <ContentTabsLayout
      tabs={
        <Chips
          size="S"
          value={[activeTab]}
          options={[
            { value: 'blogs', label: 'Блоги', counter: blogs.totalCount },
            {
              value: 'advices',
              label: 'Советы',
              counter: advices.totalCount,
            },
            { value: 'questions', label: 'Вопросы', counter: questions.totalCount },
          ]}
          selectType="single"
          onChange={handleTabChange}
        />
      }
      rating={
        <ContentRating
          rating={advices.rating}
          href={`${CONTENT_RATING_URL}${company.realtyUserId}`}
          onClick={handleClickRating}
        />
      }
      items={items}
      tabLink={tabLink}
    />
  );
};
